export const COLUMN_SIZE_HEADER = 200;
export const COLUMN_SIZE = 250;
